module.exports = __webpack_public_path__ + "static/markham2-dd10bc002f4f083d09afc5d3a24772c3.jpg";